import type { ReactNode } from 'react';
import { cx } from '../cx.js';
import { LiveBadge } from './LiveBadge.js';

export interface WebinarCardProps {
  /** Data e orario già formattati, es. "mercoledì 13 gennaio 2027 · 14:30–17:30". */
  dataOra: string;
  titolo: string;
  /** Nomi dei relatori già uniti. */
  relatori?: string;
  /** Etichetta di stato (Badge con icona e parola). */
  stato?: ReactNode;
  /** Il webinar di oggi: fondo accent-soft. */
  oggi?: boolean;
  inDiretta?: boolean;
  testoLive?: string;
  /** Un solo bottone per card. */
  azione: ReactNode;
  children?: ReactNode;
  className?: string;
}

/** Card webinar del brand book: data in body-small ink-muted, titolo title-3, relatori, un bottone. */
export function WebinarCard({ dataOra, titolo, relatori, stato, oggi, inDiretta, testoLive, azione, children, className }: WebinarCardProps) {
  return (
    <article
      data-oggi={oggi || undefined}
      className={cx('rounded-lg p-6 flex flex-col gap-4', oggi ? 'bg-accent-soft' : 'bg-surface shadow-card', className)}
    >
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <p className="t-body-small text-ink-muted">{dataOra}</p>
        <div className="flex items-center gap-2">
          {inDiretta && <LiveBadge testo={testoLive} />}
          {stato}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="t-title-3">{titolo}</h3>
        {relatori && <p className="t-body text-ink-muted">{relatori}</p>}
      </div>
      {children}
      <div className="pt-1">{azione}</div>
    </article>
  );
}
